import { Client, ClientPage } from "../dtos";
import { BaseEndpoint } from "./BaseEndpoint";
import { WithGetPage } from "./mixins/WithGetPage";

export class Endpoint extends BaseEndpoint("clients") {}

export const ClientEndpoint = WithGetPage<typeof Endpoint, Client, ClientPage>(Endpoint);
